import api from '@/apis/index';

export const customRequest = ({ file, filename, onSuccess }) => {
  const formData = new FormData();
  formData.append('file', file);
  api.uploadPic(formData).then((res) => {
    const { ret } = res;
    if (ret === '0' && res.data) {
      onSuccess(
        {
          name: filename,
          status: 'done',
          thumbUrl: res.data.urlList[0],
          url: res.data.urlList[0],
        },
        file
      );
    } else {
    }
  });

  return {
    abort() {
      console.log('upload progress is aborted.');
    },
  };
};
